import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../utils/firebase/firebase';
import { logEvent } from 'firebase/analytics';

export const usePageTracking = (pageName: string) => {
  const location = useLocation();
  useEffect(() => {
    if (analytics) {
      const params = {
        page_path: location.pathname,
        page_title: `${process.env.REACT_APP_ENV}_${pageName}`,
        environment: process.env.REACT_APP_ENV,
      };
      logEvent(analytics, 'page_view', params);
      console.log(' usePageTracking ~ usePageTracking:', params);
    }
  }, []);
};
export const useScrollTracking = (scrollEl: React.RefObject<HTMLDivElement>, pageName: string) => {
  const loggedPercents = useRef<Set<number>>(new Set()); // 로깅한 퍼센트 한번만 로깅

  useEffect(() => {
    const el = scrollEl.current;
    if (!el) return;

    const handleScroll = () => {
      const scrollTop = el.scrollTop; // 현재 세로 스크롤 위치
      const docHeight = el.scrollHeight - el.clientHeight; // 스크롤 가능한 총 높이 (콘텐츠 전체 세로 길이 - 엘리먼트의 보이는 영역 높이)
      const scrollPercent = Math.round((scrollTop / docHeight) * 100); // 현재 스크롤 위치를 총 스크롤 가능 길이로 나누고 백분율 변환

      const thresholds = [0, 25, 50, 75, 100];
      thresholds.forEach((percent) => {
        // 현재 사용자 스크롤 퍼센트가 thresholds에 들어가있는 퍼센트보다 크고, loggedPercents 없는 퍼센트 로깅
        if (scrollPercent >= percent && !loggedPercents.current.has(percent)) {
          loggedPercents.current.add(percent);
          if (analytics) {
            const params = {
              percent,
              page_title: pageName,
              environment: process.env.REACT_APP_ENV,
            };
            logEvent(analytics, 'scroll_depth', params);
            console.log(`useScrollTracking ${percent}`, params);
          }
        }
      });
    };

    el.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      el.removeEventListener('scroll', handleScroll);
    };
  }, [scrollEl, pageName]);
};

export const onClickPageButtonTracking = (pageName: string, buttonName: string) => {
  if (analytics) {
    const params = { page_title: pageName, button_name: buttonName, environment: process.env.REACT_APP_ENV };
    logEvent(analytics, 'button_click_tracking', params);
    console.log(' usePageTracking ~ usePageTracking:', params);
  }
};
